<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/tramite-carga">Trámites</router-link>
            > Cargas - Trámite {{ datoTramite.idTramite }}
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">
            help
          </span>
        </div>
      </div>
    </div>
    <hr>

    <!-- Modal de Tramite -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">

        <form>
          <div class="modal-body">
            <!-- Campos del Tramite -->
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="idTramite" class="form-label font-weight-bold">Id.</label>
                </div>
                <div class="col-3">
                  <p class="form-control-plaintext">{{ datoTramite.idTramite }}</p>
                </div>
                <div class="col-1">
                  <label for="fechaReg" class="form-label font-weight-bold">FechaReg</label>
                </div>
                <div class="col-3">
                  <p class="form-control-plaintext">{{ getFormattedDate(datoTramite.fechaReg) }}</p>
                </div>
                <div class="col-1">
                  <label for="estadoTramite" class="form-label font-weight-bold">Estado</label>
                </div>
                <div class="col-3">
                  <p class="form-control-plaintext">{{ datoTramite.estadoTramite }}</p>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="nombreComercial" class="form-label font-weight-bold">Prestador</label>
                </div>
                <div class="col-7">
                  <p class="form-control-plaintext">
                    {{ datoTramite.nombreComercial }}
                  </p>
                </div>
                <div class="col-1">
                  <label for="numCarga" class="form-label font-weight-bold">numCarga</label>
                </div>
                <div class="col-3">
                  <p class="form-control-plaintext">{{ datoTramite.numCarga }}</p>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="servicioNombre" class="form-label font-weight-bold">Servicio</label>
                </div>
                <div class="col-3">
                  <p class="form-control-plaintext">
                    {{ datoTramite.servicioNombre }}
                  </p>
                </div>
                <div class="col-1">
                  <label for="fechaDesde" class="form-label font-weight-bold">Desde</label>
                </div>
                <div class="col-3">
                  <p class="form-control-plaintext">{{ getFormattedDate(datoTramite.fechaDesde) }}</p>
                </div>
                <div class="col-1">
                  <label for="fechaHasta" class="form-label font-weight-bold">Hasta</label>
                </div>
                <div class="col-3">
                  <p class="form-control-plaintext">{{ getFormattedDate(datoTramite.fechaHasta) }}</p>
                </div>
              </div>
            </div>

            <!-- Descripción -->
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="descripcion" class="form-label font-weight-bold">Descripción</label>
                </div>
                <div class="col-11">
                  <p class="form-control-plaintext">{{ datoTramite.descripcion }}</p>
                </div>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>

    <!-- Details -->
    <hr>
    <div class="mb-3">
<!--       <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label font-weight-bold">Nombre</label></td>
          <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda"
              style="width: 500px; text-transform:uppercase;" required></td>
          <td class="centro">
            <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
              <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
            </button>
          </td>
          <td class="centro">
            <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros">
              <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
            </button>
          </td>
          <td>
          </td>
        </tr>
      </table> -->
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col">IdCarga</th>
          <th scope="col">F. Desde</th>
          <th scope="col">F. Hasta</th>
          <th scope="col">Observaciones</th>
          <th scope="col">F. Registro</th>
          <th scope="col">Opciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="carga in datosPaginados" :key="carga.idCarga" @click="handleRowClick($event, carga.idCarga)">
          <td>{{ carga.idCarga }}</td>
          <td>{{ getFormattedDate(carga.fDesde, 'DD/MM/YYYY') }}</td>
          <td>{{ getFormattedDate(carga.fHasta, 'DD/MM/YYYY') }}</td>
          <td>{{ carga.obs }}</td>
          <td>{{ getFormattedDate(carga.tramiteFechaReg, 'DD/MM/YYYY') }}</td>
          <td>
            <select class="form-select form-select-sm" @change="handleAction($event, carga.idCarga)">
              <option disabled selected>Seleccione...</option>
              <option value="resumen">Resumen</option>
              <option value="detalles">Detalles</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click="getDataPaginaTodos(pagina)"
          class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{ pagina }}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>

    <!-- Modal -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>

          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar_det">
                <div class="row">
                  <div class="col-2">
                    <label for="idCarga" class="form-label font-weight-bold">IdCarga</label>
                  </div>
                  <div class="col-10">
                    <p class="form-control-plaintext">{{ datoCarga.idCarga }}</p>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idTramite" class="form-label font-weight-bold">IdTramite</label>
                  </div>
                  <div class="col-10">
                    <p class="form-control-plaintext">{{ datoCarga.idTramite }}</p>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fDesde" class="form-label font-weight-bold">FDesde</label>
                  </div>
                  <div class="col-10">
                    <p class="form-control-plaintext">{{ datoCarga.fDesde }}</p>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fHasta" class="form-label font-weight-bold">FHasta</label>
                  </div>
                  <div class="col-10">
                    <p class="form-control-plaintext">{{ datoCarga.fHasta }}</p>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="obs" class="form-label font-weight-bold">Obs</label>
                  </div>
                  <div class="col-10">
                    <p class="form-control-plaintext">{{ datoCarga.obs }}</p>
                  </div>
                </div>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
    <!-- Details -->

    <Footer />
  </div>
</template>
<script>
import Layout from '../../components/Layout.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import dateFormat from '../../modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from 'sweetalert'
export default {
  components: {
    Layout, Footer
  },
  data() {
    return {
      // Variables master
      tramites: [],
      datoTramite: {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idTramite: '',
      prestadors: [],
      servicios: [],
      // Variables master
      // Variables details
      cargas: [],
      datoCarga: {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      // tramites : [],
      modalWindow: true
      // Variables details
    }
  },
  mounted() {
    this.p_idTramite = this.$route.params.p_idtramite
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.abrirEditar(this.p_idTramite)
    this.getDataPaginaTodos(this.paginaActual)
  },
  methods: {
    handleRowClick(event, idCarga) {
      if (event.target.tagName === 'SELECT' || event.target.tagName === 'OPTION') {
        return;
      }
      this.abrirEditarDet(idCarga);
    },
    handleAction(event, idCarga) {
      const action = event.target.value;
      if (action === 'resumen') {
        this.abrirModalEditar(idCarga);
      } else if (action === 'detalles') {
        this.abrirEditarDet(idCarga);
      }
      event.target.value = 'Seleccione...';
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    // Procedimientos master
    validarForm() {
      const requiredFields = [
        'idPrestador'
        , 'idServicio'
        , 'fechaDesde'
        , 'fechaHasta'
        , 'descripcion'
      ];
      const requiredFieldsText = [
        'idPrestador'
        , 'idServicio'
        , 'fechaDesde'
        , 'fechaHasta'
        , 'descripcion'
      ];
      return validarForm(this.datoTramite, requiredFields, requiredFieldsText);
    },
    async guardarEditTramite() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/tramites', this.datoTramite)
          swal("Correcto!", "Tramite creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear() {
      this.modalWindow = true
      this.datoTramite = {}
      this.titulo = 'Crear '
      this.btnCrear = true
      this.btnEditar = false
    },
    abrirEditar(idTramite) {
      this.modalWindow = true
      if (idTramite != null) {
        api.get('/vwtramites/' + idTramite).then(resp => {
          this.datoTramite = resp.data;
        });
      }
    },
    cerrarTramite() {
      this.$router.push('/Tramite')
    },
    // Procedimientos master
    // Procedimientos detalle
    totalPaginas() {
      return Math.ceil(this.cargas.length / this.elementosPorPagina)
    },
/*     getDataPagina(noPagina) {
      if (this.nombreBusqueda != '') {
        api.get('/vwcargas/nombre/' + this.nombreBusqueda).then(response => {
          this.cargas = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.cargas.slice(ini, fin);
        });
      }
    }, */
    getDataPaginaTodos(noPagina) {
      api.get('/vwcargas/idtramite/' + this.p_idTramite).then(response => {
        this.cargas = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
        let fin = (noPagina * this.elementosPorPagina);
        this.datosPaginados = this.cargas.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet() {
      const requiredFields = [
        'idPrestador'
        , 'idServicio'
        , 'fechaDesde'
        , 'fechaHasta'
        , 'descripcion'
      ];
      const requiredFieldsText = [
        'idPrestador'
        , 'idServicio'
        , 'fechaDesde'
        , 'fechaHasta'
        , 'descripcion'
      ];
      return validarForm(this.datoTramite, requiredFields, requiredFieldsText);
    },
    abrirModalEditar(idCarga) {
      this.modalWindow = true
      if (idCarga != null) {
        api.get('/vwcargas/' + idCarga).then(resp => {
          this.datoCarga = resp.data;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo = 'Resumen'
      this.btnCrear_det = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idCarga) {
      this.modalWindow = true
      if (idCarga != null) {
        this.$router.push('/cargaform/' + this.p_idTramite + '/' + idCarga)
      }
    },

  },
}
</script>